import { render, staticRenderFns } from "./SignageModule.vue?vue&type=template&id=9c05b24a&"
import script from "./SignageModule.vue?vue&type=script&lang=js&"
export * from "./SignageModule.vue?vue&type=script&lang=js&"
import style0 from "./SignageModule.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports